function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#808185",
  d: "M462.736,65.6567c0-24.2097-19.6958-43.9058-43.9054-43.9058H66.1701c-24.2096,0-43.9062,19.6961-43.9062,43.9058v352.6604c0,24.2096,19.6966,43.9061,43.9062,43.9061h352.6605c24.2096,0,43.9054-19.6966,43.9054-43.9061V65.6567ZM440.9851,418.3172c0,12.2167-9.9386,22.1552-22.1545,22.1552H66.1701c-12.2167,0-22.1553-9.9385-22.1553-22.1552V65.6567c0-12.2164,9.9386-22.1549,22.1553-22.1549h352.6605c12.2159,0,22.1545,9.9385,22.1545,22.1549v352.6604Z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M418.8306,21.7509c24.2096,0,43.9054,19.6961,43.9054,43.9058v352.6604c0,24.2096-19.6958,43.9061-43.9054,43.9061H66.1701c-24.2096,0-43.9062-19.6966-43.9062-43.9061V65.6567c0-24.2097,19.6966-43.9058,43.9062-43.9058h352.6605M66.1701,440.4724h352.6605c12.2159,0,22.1545-9.9385,22.1545-22.1552V65.6567c0-12.2164-9.9386-22.1549-22.1545-22.1549H66.1701c-12.2167,0-22.1553,9.9385-22.1553,22.1549v352.6604c0,12.2167,9.9386,22.1552,22.1553,22.1552M418.8306,0H66.1701C29.9667,0,.513,29.4535.513,65.6567v352.6604c0,36.2034,29.4537,65.6571,65.6571,65.6571h352.6605c36.203,0,65.6563-29.4536,65.6563-65.6571V65.6567c0-36.2032-29.4533-65.6567-65.6563-65.6567h0Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#808185",
  d: "M76.7758,418.7214h331.4484c6.0555,0,11.01-4.9545,11.01-11.01v-56.312H65.7658v56.312c0,6.0555,4.9545,11.01,11.01,11.01Z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#808185",
  d: "M408.2242,61.3003H76.7758c-6.0555,0-11.01,4.9545-11.01,11.01v211.7661h353.4684V72.3104c0-6.0555-4.9545-11.01-11.01-11.01Z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#808185",
  d: "M171.3537,304.6382h-4.8195l-9.4197,26.2874h5.5864l1.9108-5.8049h9.8779l1.9028,5.8049h5.8413l-9.4197-26.2874h-1.4603ZM166.0541,320.739l3.5067-10.6539,3.4925,10.6539h-6.9991Z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#808185",
  d: "M197.2762,315.1758c-.3345-.7865-.8381-1.4605-1.5521-1.9941-1.1076-.8276-2.5497-1.2418-4.3264-1.2418-1.7038,0-3.1945.4021-4.4728,1.2054-1.2775.8026-2.2698,1.9345-2.9753,3.3955-.7063,1.4603-1.059,3.1763-1.059,5.1479,0,1.9474.3406,3.6391,1.0226,5.0744.6812,1.4368,1.6485,2.5505,2.9024,3.3409,1.2532.7912,2.7318,1.1865,4.4356,1.1865,1.6796,0,3.1217-.4013,4.3271-1.2047.8354-.5571,1.434-1.2458,1.807-2.0602v2.9h5.3672v-26.2874h-5.4764v10.5376ZM196.1444,325.5403c-.8034.9126-1.8503,1.3693-3.1399,1.3693-1.3147,0-2.3798-.4499-3.1953-1.3511-.8155-.8997-1.2229-2.2023-1.2229-3.9069,0-1.7031.4074-3.0178,1.2229-3.9425s1.8563-1.3875,3.1217-1.3875c1.3147,0,2.379.4559,3.1945,1.3693.8155.9126,1.2236,2.2212,1.2236,3.9243,0,1.7046-.4021,3.0124-1.2047,3.9251Z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "#808185",
  points: "218.4339 312.3055 214.2665 325.0214 210.0725 312.3055 204.1948 312.3055 211.5328 330.9257 216.8272 330.9257 224.166 312.3055 218.4339 312.3055"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#808185",
  d: "M241.5443,327.0924v-8.215c0-2.2394-.7063-3.9554-2.1173-5.1479-1.4125-1.1925-3.457-1.7896-6.1341-1.7896-2.58,0-4.6131.5477-6.097,1.6432-1.4854,1.0954-2.3494,2.4829-2.5922,4.1625h5.2208c.1699-.6084.5295-1.0712,1.0772-1.3875s1.2836-.4749,2.2083-.4749c.9733,0,1.7099.2139,2.2091.6395.4984.4256.7487,1.0165.7487,1.7706v.9581l-4.6002.6479c-2.3365.3171-4.1564,1.0044-5.4582,2.0634-1.3025,1.0583-1.9534,2.4518-1.9534,4.18,0,1.5582.5477,2.8061,1.6424,3.7422,1.0954.9376,2.5679,1.4057,4.4182,1.4057,1.5817,0,2.9207-.3528,4.0161-1.0583.8842-.5701,1.5766-1.3731,2.096-2.3866.0137.4925.0357.9581.0766,1.364.0599.6084.1639,1.1812.3103,1.716h5.4764c-.195-.7055-.3345-1.3693-.4203-1.9898-.085-.6205-.1274-1.235-.1274-1.8434ZM234.8632,326.3436c-.8034.6205-1.7774.9308-2.9214.9308-.7298,0-1.3139-.1578-1.7524-.4741-.4377-.3163-.657-.7791-.657-1.3875,0-.6812.2306-1.2168.6934-1.6067.462-.3892,1.1804-.657,2.1545-.8034l3.6876-.5648v1.733c0,.8276-.4021,1.5521-1.2047,2.1727Z"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#808185",
  d: "M257.0905,311.9399c-1.7289,0-3.1824.4081-4.3628,1.2236-.9699.6697-1.7355,1.5343-2.3191,2.5728v-3.4308h-5.3664v18.6201h5.4764v-10.0038c0-.9247.1881-1.7281.5659-2.4101.377-.6805.9005-1.2168,1.5696-1.606s1.43-.5841,2.2819-.5841c.9983,0,1.7585.2557,2.2819.7662.5234.5113.7852,1.2783.7852,2.3009v11.537h5.4764v-12.596c0-1.9474-.5477-3.4987-1.6424-4.6548-1.0954-1.1561-2.6779-1.7349-4.7466-1.7349Z"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#808185",
  d: "M273.3673,316.9058c.6441-.4385,1.4049-.657,2.2819-.657.924,0,1.7342.2314,2.4276.6934.6934.4628,1.1743,1.144,1.4421,2.0445h5.2944c-.2435-1.411-.7852-2.6407-1.6249-3.6876-.8398-1.0461-1.9109-1.8677-3.2127-2.464-1.3025-.5963-2.7697-.8952-4.3999-.8952-1.9474,0-3.6633.4142-5.1479,1.2418s-2.6468,1.9716-3.4866,3.432-1.2593,3.1278-1.2593,5.0015.4195,3.542,1.2593,5.0023,2.002,2.6051,3.4866,3.432c1.4846.8276,3.2006,1.2411,5.1479,1.2411,1.6303,0,3.0974-.2981,4.3999-.8944,1.3018-.5963,2.3729-1.4178,3.2127-2.464.8398-1.0469,1.3814-2.2758,1.6249-3.6876h-5.2944c-.2678.9005-.7487,1.5825-1.4421,2.0445-.6934.4628-1.5036.6934-2.4276.6934-.877,0-1.6378-.2192-2.2819-.657-.6456-.4385-1.1387-1.059-1.4793-1.8624-.3406-.8026-.5105-1.7524-.5105-2.8478,0-1.0947.1699-2.0445.5105-2.8478.3406-.8026.8337-1.4239,1.4793-1.8616Z"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#808185",
  d: "M300.8768,313.1089c-1.4118-.7791-3.0792-1.169-5.0015-1.169-1.9959,0-3.7491.4081-5.2579,1.2236s-2.6832,1.9474-3.523,3.3955-1.2593,3.1338-1.2593,5.0561c0,1.8988.4195,3.5784,1.2593,5.0387s2.0263,2.5982,3.5594,3.4138c1.5339.8155,3.3349,1.2229,5.4036,1.2229,2.3122,0,4.205-.5166,5.6775-1.5514s2.5133-2.4518,3.1217-4.2535h-5.1479c-.3163.657-.7912,1.1318-1.4239,1.4239-.6334.2921-1.3875.4377-2.2637.4377-1.5825,0-2.7689-.462-3.5594-1.3867-.5602-.6548-.9179-1.5591-1.0812-2.7022h13.8047c.0486-.2921.085-.6023.11-.9308.0235-.3285.0364-.6873.0364-1.0772,0-1.8738-.3899-3.5048-1.1683-4.8923-.7791-1.3875-1.8745-2.47-3.2863-3.2491ZM295.8025,315.8831c1.2411,0,2.2205.3596,2.9389,1.0772.6061.6067.9409,1.5128,1.0353,2.6832h-8.3129c.1891-.943.5198-1.7118.9978-2.3001.7905-.9733,1.9041-1.4603,3.3409-1.4603Z"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#808185",
  d: "M321.0969,304.6382v10.5376c-.3345-.7865-.8381-1.4605-1.5521-1.9941-1.1076-.8276-2.5497-1.2418-4.3264-1.2418-1.7038,0-3.1945.4021-4.4728,1.2054-1.2775.8026-2.2698,1.9345-2.9753,3.3955-.7063,1.4603-1.059,3.1763-1.059,5.1479,0,1.9474.3406,3.6391,1.0226,5.0744.6812,1.4368,1.6485,2.5505,2.9024,3.3409,1.2532.7912,2.7318,1.1865,4.4356,1.1865,1.6796,0,3.1217-.4013,4.3271-1.2047.8354-.5571,1.434-1.2458,1.807-2.0602v2.9h5.3672v-26.2874h-5.4764ZM319.965,325.5403c-.8034.9126-1.8503,1.3693-3.1399,1.3693-1.3147,0-2.3798-.4499-3.1953-1.3511-.8155-.8997-1.2229-2.2023-1.2229-3.9069,0-1.7031.4074-3.0178,1.2229-3.9425s1.8563-1.3875,3.1217-1.3875c1.3147,0,2.379.4559,3.1945,1.3693.8155.9126,1.2236,2.2212,1.2236,3.9243,0,1.7046-.4021,3.0124-1.2047,3.9251Z"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M402.7163,159.676c-.0035,1.2635-.3301,2.4423-.9794,3.5365-.6495,1.0942-1.5363,1.9572-2.6602,2.5885-1.1244.6313-2.3385.9454-3.643.9418-1.2988-.0036-2.5085-.3243-3.6292-.9618-1.1207-.6375-2.0027-1.5053-2.6459-2.6031-.6435-1.0977-.9634-2.2784-.9599-3.5419.0027-.9871.1935-1.9106.5719-2.7706.3782-.86.9049-1.6133,1.5794-2.2612.6748-.6471,1.4562-1.1519,2.3445-1.5136.8882-.3617,1.8143-.5417,2.7782-.539.9811.0027,1.9166.1878,2.8059.5544s1.6649.8713,2.3273,1.5133c.6622.6428,1.1801,1.3946,1.5538,2.2566.3737.862.5594,1.7954.5566,2.8001ZM400.9097,159.5127c.0021-.7583-.1355-1.4623-.4128-2.1124-.2775-.6502-.6665-1.2257-1.1677-1.7265-.501-.5009-1.086-.89-1.7552-1.1687-.6691-.2778-1.3651-.4177-2.0879-.4197-.7171-.002-1.4122.1359-2.086.4126-.6735.2777-1.2578.6596-1.7527,1.1458-.4951.4862-.886,1.0627-1.1728,1.7289-.2868.6662-.4312,1.3694-.4332,2.1101-.0027.9866.2373,1.8972.7197,2.73.4824.8328,1.1388,1.4924,1.9689,1.9796.8301.4872,1.7389.7322,2.7262.7349.9928.0027,1.9058-.239,2.7389-.7243.8328-.4853,1.4928-1.143,1.9798-1.9731s.732-1.7359.7347-2.7172ZM398.8814,163.0944l-2.1155-.0058c-.3857-.8061-.7204-1.4432-1.0041-1.9112-.2837-.4681-.5047-.7491-.6632-.8434-.1761-.0829-.3874-.1245-.6343-.1252l-.0079,2.8735-1.7894-.0049.0198-7.2102,3.2174.0089c.7991.0022,1.4319.1671,1.8981.4946.4664.3271.6984.8466.6965,1.5573-.0018.641-.2028,1.1104-.6032,1.4091-.4005.2982-.8533.4941-1.359.5866.3932.1774.6966.4031.9105.6766.2137.2739.4696.6934.7678,1.2586l.6665,1.2358ZM396.6564,158.0286c.0008-.3051-.1207-.532-.364-.6795-.2434-.1475-.5679-.222-.9732-.2231l-.8462-.0023-.0049,1.7983.7757.0021c.4583.0013.8081-.067,1.0494-.2043s.3625-.3676.3634-.6912Z"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M82.2841,194.4177c.0661-24.2841,18.1537-42.9768,43.1449-42.9084,15.0891.0415,28.5074,7.7406,35.6642,19.6664l-18.2994,10.4422c-3.1677-5.9041-9.7587-9.4584-17.4209-9.4797-13.3209-.037-22.07,9.1346-22.1058,22.3378-.037,13.2032,8.6617,22.4207,21.9826,22.4577,7.6622.0213,14.2733-3.4972,17.4724-9.4999l18.2422,10.6596c-7.2229,11.8866-20.5651,19.5118-35.7718,19.4703-24.9912-.0684-42.9757-18.8619-42.9084-43.146Z"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  opacity: 0.99,
  d: "M234.0005,153.5755l-.2263,82.518-20.983-.0571.0863-31.711-23.223-.0639-.0863,31.711-21.1018-.0583.2263-82.518,21.1018.0583-.084,30.5311,23.223.0639.084-30.5311,20.983.0571Z"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M293.6956,224.3515l-27.4675-.0751-3.5689,11.8967-22.8689-.0627,27.4575-82.443,25.6982.0706,27.0048,82.5931-22.7512-.0627-3.5039-11.9168ZM288.3215,206.1832l-8.2919-28.0782-8.3289,28.0323,16.6208.0459Z"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M319.9127,217.588l18.0641-10.4422c2.9279,7.0806,7.986,10.9857,16.2376,11.0081,7.4269.0202,9.6735-2.6848,9.6814-5.5141.0134-4.7152-5.4054-6.1461-15.8891-9.1211-12.9556-3.8076-24.4903-10.4422-24.4477-25.8842.0426-15.4431,12.6822-25.5458,28.7147-25.501,13.6749.037,24.8567,6.5517,30.5983,18.9448l-17.7111,10.3257c-2.5761-6.1371-6.8117-9.2141-12.8245-9.2309-5.1869-.0146-7.6689,2.4551-7.6767,5.4021-.0101,3.654,2.9313,5.6654,14.1209,8.9979,12.7214,3.8076,26.2652,8.5597,26.2182,25.8887-.0459,16.3855-12.8032,25.7811-31.4286,25.7296-17.9184-.0493-29.3299-8.4499-33.6574-20.6032Z"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M317.786,107.0175c-.0013.4605-.1203.8902-.357,1.289-.2367.3988-.5599.7134-.9696.9434-.4098.2301-.8523.3446-1.3278.3433-.4734-.0013-.9143-.1182-1.3228-.3506s-.7299-.5487-.9644-.9488c-.2345-.4001-.3511-.8304-.3499-1.2909.001-.3598.0705-.6964.2085-1.0098.1378-.3134.3298-.588.5757-.8242.2459-.2359.5308-.4199.8545-.5517s.6613-.1974,1.0126-.1965c.3576.001.6986.0684,1.0227.2021s.6068.3176.8483.5516c.2413.2343.4301.5083.5663.8225.1362.3142.2039.6544.2029,1.0206ZM317.1275,106.958c.0008-.2764-.0494-.533-.1505-.7699-.1011-.237-.2429-.4467-.4256-.6293-.1826-.1826-.3958-.3244-.6397-.426-.2439-.1013-.4975-.1523-.761-.153-.2614-.0007-.5147.0495-.7603.1504-.2455.1012-.4585.2404-.6388.4176-.1805.1772-.3229.3873-.4275.6302s-.1572.4991-.1579.7691c-.001.3596.0865.6915.2623.995s.4151.5439.7176.7215.6338.2669.9937.2679c.3619.001.6946-.0871.9983-.264.3035-.1769.5441-.4166.7216-.7192s.2668-.6327.2678-.9904ZM316.3882,108.2635l-.771-.0021c-.1406-.2938-.2626-.526-.366-.6966s-.184-.273-.2417-.3074c-.0642-.0302-.1412-.0454-.2312-.0456l-.0029,1.0473-.6522-.0018.0072-2.628,1.1727.0032c.2912.0008.5219.0609.6918.1803.17.1192.2546.3086.2538.5676-.0006.2336-.0739.4047-.2199.5136-.146.1087-.311.1801-.4953.2138.1433.0647.2539.1469.3319.2466.0779.0998.1712.2527.2799.4587l.2429.4504ZM315.5772,106.4171c.0003-.1112-.044-.1939-.1327-.2477s-.207-.0809-.3547-.0813l-.3084-.0008-.0018.6554.2827.0008c.167.0005.2945-.0244.3825-.0745s.1321-.134.1325-.2519Z"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M197.0591,124.6315c2.2265.0061,3.899-.9912,4.7933-2.2876l3.2974,1.9388c-1.714,2.5187-4.5013,4.0324-8.1379,4.0224-6.1229-.0168-10.082-4.221-10.0667-9.7873.0151-5.4921,3.9975-9.7486,9.8234-9.7325,5.5292.0152,9.302,4.4786,9.2873,9.8222-.0015.5567-.0773,1.1502-.1531,1.6696l-14.7691-.0406c.6228,2.8961,2.9566,4.387,5.9253,4.3951ZM202.0156,117.0006c-.5479-3.1928-2.882-4.5723-5.294-4.5789-3.0058-.0083-5.0518,1.7673-5.6159,4.5489l10.9099.03Z"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M221.7803,109.3363l4.0077.011-.0511,18.5543-4.0077-.011.0511-18.5543Z"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M235.4339,109.0383l-.001.3711,4.0594.0112-.0106,3.8594-4.0594-.0112-.0404,14.695-4.0077-.011.0404-14.695-2.4201-.0067.0106-3.8594,2.4201.0067.001-.3711c.0138-5.0096,2.5226-7.8973,8.0878-7.5108l-.0106,3.8594c-2.8195-.2675-4.0617.8052-4.0695,3.6625Z"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M240.6769,118.7011c.0152-5.5292,4.4056-9.7474,9.8234-9.7325,5.4551.015,9.7851,4.2573,9.7699,9.7865-.0151,5.4921-4.3686,9.7476-9.8236,9.7325-5.4178-.0149-9.7848-4.2943-9.7697-9.7865ZM256.2623,118.744c.0093-3.3769-2.5071-5.8702-5.7728-5.8792-3.2654-.009-5.7957,2.4704-5.805,5.8473-.0093,3.3769,2.5073,5.8702,5.7728,5.8792,3.2657.009,5.7957-2.4704,5.805-5.8473Z"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M272.5684,109.1778l-.0119,4.3417c-2.6341-.1928-5.6757,1.0234-5.6871,5.1795l-.0257,9.3513-4.0077-.011.0511-18.5544,4.0077.011-.0086,3.1172c1.1203-2.5204,3.3445-3.4418,5.6823-3.4354Z"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M218.5544,108.9936l-.0119,4.3417c-2.6341-.1928-5.6757,1.0234-5.6871,5.1795l-.0257,9.3513-4.0077-.011.0511-18.5544,4.0077.011-.0086,3.1172c1.1203-2.5204,3.3445-3.4418,5.6823-3.4354Z"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M273.707,118.7565c.0152-5.5292,4.2201-9.748,9.8234-9.7325,3.6366.01,6.7856,1.9111,8.2621,4.8097l-3.4567,1.9943c-.8116-1.7464-2.6268-2.8645-4.8532-2.8706-3.2657-.009-5.7587,2.4703-5.7679,5.8101-.0092,3.3398,2.4701,5.833,5.7358,5.842,2.2265.0061,4.0479-1.1393,4.9433-2.8439l3.4456,1.9763c-1.5667,2.9273-4.7261,4.8111-8.3627,4.8011-5.6033-.0154-9.7848-4.2943-9.7697-9.7865Z"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M303.7548,124.9251c2.2265.0061,3.899-.9912,4.7933-2.2876l3.2974,1.9388c-1.714,2.5187-4.5013,4.0324-8.1379,4.0224-6.1229-.0168-10.082-4.221-10.0667-9.7873.0151-5.4921,3.9975-9.7486,9.8234-9.7325,5.5292.0152,9.302,4.4786,9.2873,9.8222-.0015.5567-.0773,1.1502-.1531,1.6696l-14.7691-.0406c.6228,2.8961,2.9566,4.387,5.9253,4.3951ZM308.7113,117.2942c-.5479-3.1928-2.882-4.5723-5.294-4.5789-3.0058-.0083-5.0518,1.7673-5.6159,4.5489l10.9099.03Z"
});

var _ref28 =
/*#__PURE__*/
React.createElement("rect", {
  fill: "#fff",
  x: 221.7948,
  y: 102.0814,
  width: 4.0077,
  height: 4.0077,
  transform: "translate(119.0979 327.5966) rotate(-89.8423)"
});

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M181.4707,109.2254l-.0005.1732c-.1074,2.8108-.8984,9.7847-5.7115,14.0249-1.0839-.9655-1.952-2.0732-2.6616-3.2368l-4.5431-.0125c2.4676,5.1947,5.9443,7.3299,6.1648,7.4612l1.0266.6112,1.03-.6055c.3367-.1981,8.2503-5.0006,8.6983-18.2202l.0046-.1844-4.0077-.0111Z"
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M170.8638,114.6884l-4.1321-.0114c.2962,1.4179.6807,2.7045,1.1244,3.8625l4.3614.012c-.608-1.2961-1.0449-2.615-1.3537-3.8632Z"
});

var _ref31 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M170.1245,109.3674l.0005-.1732-4.0077-.011.0036.1844c.0371,1.307.15,2.529.3193,3.6759l4.075.0112c-.2662-1.4993-.3618-2.8009-.3907-3.6873Z"
});

var SvgChasAdvanced = function SvgChasAdvanced(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 485 485.3",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChasAdvanced, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CHAS Advanced.5fb5275e.svg";
export { ForwardRef as ReactComponent };